module.exports = __webpack_public_path__ + "img/teacher3.3722c7a0.png";